// extracted by mini-css-extract-plugin
export var background = "styles-module--background--717b0";
export var backgroundCTA = "styles-module--backgroundCTA--59dbd";
export var blockquote = "styles-module--blockquote--b66db";
export var defaultCard = "styles-module--defaultCard--fcea7";
export var fiveCard = "styles-module--fiveCard--deeb8";
export var imageWrapper = "styles-module--imageWrapper--73bcd";
export var qlikTabSlider = "styles-module--qlikTabSlider--d3cb1";
export var threeCard = "styles-module--threeCard--abc73";